import { render, staticRenderFns } from "./downloadPolicyPopup.vue?vue&type=template&id=2d53215e"
import script from "./downloadPolicyPopup.vue?vue&type=script&lang=js"
export * from "./downloadPolicyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports